import moment from "moment"

export const getEndOfBillingPeriodView = (billingPeriodEndsAt) => {
    const utc = moment.utc(billingPeriodEndsAt)
    utc.subtract(1, 'seconds')
    return utc
  }